// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"89d81d30","417":"89d81d30"}[chunkId] + ".chunk.css";
};